import template from './feature-filter-labeled.template.html'

/* @ngInject */
export default function featureFilterIconDirective() {
  return {
    template
  }
}
